
<div
	class="flow-tag text-ellipsis"
	:size="size"
	:type="type"
	:shape="shape"
	:style="styleObj"
	:data-clickable="clickable"
	@click="handleClick($event)"
>
	<!-- @slot Used to display text + Icon (optional)  -->
	<slot />
</div>
